import GlobalLoader from '../components/GlobalLoader.js'
import { Navigate } from 'react-router-dom'
import { useOrgUser } from '../context/OrgUserProvider'

export default function RequireAuth({ component, roles, org }) {
  const { orgUser } = useOrgUser()

  return (
    Object.keys(orgUser).length === 0 ? <GlobalLoader />
    : (
      ((!roles &&
        ['IT', 'SuperAdmin', 'Admin', 'Operations', 'eCommerce'].includes(orgUser.role)) ||
        roles?.includes(orgUser.role)) &&
      (!org || org?.includes(orgUser.orgName))
    ) ?
      component
    : <Navigate replace to='/401' />
  )
}
